import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
// import { ClassificationDataProvider } from 'src/app/dataproviders/classification.dataprovider';
// import { ImageClaim } from 'src/app/models/image-claim.model';
// import { ImageRecognitionResult } from 'src/app/models/image-recognition-result.model';
// import { Converters } from 'src/app/utils/converters';
import * as _ from 'lodash';
// import { ImageFile } from 'src/app/models/image-file.model';
import { Document } from '../../../models/document.model';
import { DocumentType } from '../../../static/document-type.enum';
// import { Const } from 'src/app/static/const';
// import { Metadata } from 'src/app/models/metadata.model';
// import { Claim } from 'src/app/models/claim.model';
// import { ClaimClass } from 'src/app/enums/claim-class.enum';
// import { RegionBox } from 'src/app/models/region-box.model';
// import { ClassificationResult } from 'src/app/models/classification-result.model';
// import { ClassificationRequest } from 'src/app/models/classification-request.model';
// import { ClassificationReport } from 'src/app/models/classification-report.model';
// import { TextClaim } from 'src/app/models/text-claim.model';
import { ClassificationDataProvider } from '../../../dataproviders/classification.dataprovider';
import { ImageClaim } from '../../../models/image-claim.model';
import { ImageRecognitionResult } from '../../../models/image-recognition-result.model';
import { ImageFile } from '../../../models/image-file.model';
import { Converters } from '../../../static/converters';
import { TextClaim } from '../../../models/text-claim.model';
import { Metadata } from 'pdfjs-dist/types/src/display/metadata';
import { RegionBox } from '../../../models/region-box.model';
import { Const } from '../../../static/const';
import { Page } from '../../../models/page.model';
import { ClassificationReport } from '../../../models/classification-report.model';
import { ClassificationRequest } from '../../../models/classification-request.model';
import { Claim } from '../../../models/claim.model';
import { ClaimClass } from '../../../static/claim-class.enum';
import { ClassificationResult } from '../../../models/classification-result.model';
export class DisclaimersError extends Error {}
@Injectable({
  providedIn: 'root',
})
// export class DisclaimersError extends Error {}
export class PreviewService {
  radioValue = new Subject();
  radioSelectionValue$ = this.radioValue.asObservable();

  docDataSubject = new BehaviorSubject<any>({});
  documentData$ = this.docDataSubject.asObservable();

  constructor(
    private classificationDataProvider: ClassificationDataProvider,
    private http: HttpClient
  ) {}

  updatedPageSubject = new BehaviorSubject<Page>({
    image: '',
    text: '',
    qualifiertext: '',
    textClaims: [],
    qualifierClaims: [],
    imageClaims: [],
    unit8ImgData: '',
  });
  updatedPageData$ = this.updatedPageSubject.asObservable();

  changeSelection(selectedOption: any) {
    this.radioValue.next(selectedOption);
  }

  //text detection
  recognizeImage(document: Document, pageNumber: number): Observable<any> {
    const imageFile = _.first(this.getImages(document, pageNumber));

    return this.classificationDataProvider.getTextOcr(imageFile).pipe(
      map((response: any) => {
        return {
          region: response.map((value) => {
            return value.coordinates__c;
          }),
          text: response.map((value) => {
            return value.statement__c.trim();
          }),
          qualifier: response.map((value) => {
            return value.qualifier_text;
          }),
        };
      })
    );
  }

  recognizeRegion(
    imageClaim: ImageClaim,
    image: any
  ): Observable<ImageRecognitionResult> {
    const imageFile: any = {
      Label: imageClaim.className,
      region: {
        xmin: imageClaim.region.leftTopX,
        ymin: imageClaim.region.leftTopY,
        xmax: imageClaim.region.rightBottomX,
        ymax: imageClaim.region.rightBottomY,
      },
      environment: localStorage.getItem('environment'),
      application: 'EEOC',
      image: image.split(',')[1],
    };

    return this.classificationDataProvider.getEEOCRegionTextOcr(imageFile).pipe(
      map((response: any) => {
        return {
          label: imageClaim.className,
          text: response.text,
        };
      })
    );
  }

  //image detection
  detectImage(document: Document, pageNumber: number): Observable<any> {
    console.log('document', document);
    console.log('pageNumber', pageNumber);
    const imageFile = _.first(this.getImages(document, pageNumber));
    return this.classificationDataProvider.getEeocImageDetections(imageFile);
  }

  private getImages(document: Document, pageNumber?: number): ImageFile[] {
    if (!document || !document.pages) {
    return [];
  }
    console.log('document', document);
    console.log('pageNumber', pageNumber);
    if (document.type === DocumentType.TEXT) {
      return [];
    }
    if (document.type === DocumentType.IMAGE) {
      return [
        {
          base64: document.pages[0].image,
          blob: document.file,
          fileName: document.file?.name,
        },
      ];
    }

    if (pageNumber != null) {
      const page: any = document.pages[pageNumber];
      return [
        {
          base64: page.image,
          blob: Converters.dataURItoBlob(page.image),
          fileName: this.getPageFileName(document.file?.name!, pageNumber),
          pageno: pageNumber,
        },
      ];
    }
    return document.pages.map<ImageFile>((page: any, index: any) => {
      return {
        base64: page.image,
        blob: Converters.dataURItoBlob(page.image),
        fileName: this.getPageFileName(document.file?.name!, index),
        pageno: index,
      };
    });
  }

  public getTexts(document: Document): any[] {
   if (!document || !document.pages) {
    return [];
  }
   
    return document.pages.map<any>((page: any, index: any) => {
      console.log('page', page);
      const textClaims: TextClaim[] = [];
      if (page.textClaims.length) {
        for (let i = 0; i < page.textClaims.length; i++) {
          textClaims.push(page.textClaims[i]);
        }
        page.textValues = textClaims;
        return page.textValues;
      } else {
        return (page.textValues = []);
      }
    });
  }

  private getQualifiers(document: Document): any[] {
    return document.pages.map<any>((page: any, index: any) => {
      const qualifierClaims: TextClaim[] = [];
      if (page?.qualifierClaims) {
        if (page.qualifierClaims.length) {
          for (let i = 0; i < page.qualifierClaims.length; i++) {
            qualifierClaims.push(page.qualifierClaims[i]);
          }
          page.qualifierValues = qualifierClaims;
          return page.qualifierValues;
        } else {
          return page.qualifierValues;
        }
      }
    });
  }

  private getPageFileName(fileName: string, pageNumber: number): string {
    if (fileName == null || fileName.length === 0) {
      return `${pageNumber + 1}.jpeg`;
    }
    const index = fileName.lastIndexOf('.');
    if (index >= 0) {
      return `${fileName.substring(0, index)}_${pageNumber + 1}.jpeg`;
    } else {
      return `${fileName}_${pageNumber + 1}.jpeg`;
    }
  }

  async getResultTableData(
    document: Document,
    marketingChannels: [],
    fileBase64: any,
    textData: []
  ): Promise<ClassificationReport> {
    // const textData = this.getTexts(document);
    const qualifierData = this.getQualifiers(document);
    const requestPromise = this.classificationDataProvider
      .getResultTableData(
        textData,
        qualifierData,
        marketingChannels,
        fileBase64
      )
      .pipe(
        map((response: any) => {
          return response;
        })
      )
      .toPromise();
    // await this.cropImages(imageFiles, document);
    const classificationResponse = await requestPromise;
    return classificationResponse;
  }

  //to get result from classify_imag API for initiate IRA in Preview Page
  async getIRAClassification(
    document: Document,
    metadata: any,
    btnClick: boolean,
    isExcel: boolean,
    qualifiers: any,
    marketingChannels: any
  ): Promise<ClassificationReport> {
    const request: ClassificationRequest = {
      claims: [],
      metadata,
    };
    let disclaimers: Claim[] = [];
    document.pages.forEach((page, pageNumber) => {
      if (isExcel == false) {
        if (page.imageClaims.length > 0) {
          page.imageClaims.forEach((imageClaim) => {
            if (imageClaim.className === ClaimClass.DISCLAIMER) {
              disclaimers = _.concat(
                disclaimers,
                this.getClaimsFromImageClaim(
                  imageClaim,
                  pageNumber,
                  btnClick,
                  true
                )
              );
              request.claims = _.concat(
                request.claims,
                this.getClaimsFromImageClaim(
                  imageClaim,
                  pageNumber,
                  btnClick,
                  true
                )
              );
            } else {
              request.claims = _.concat(
                request.claims,
                this.getClaimsFromImageClaim(
                  imageClaim,
                  pageNumber,
                  btnClick,
                  false
                )
              );
            }
          });
          return;
        }
      } else {
        if (page.textClaims.length > 0) {
          request.claims = _.concat(
            request.claims,
            page.textClaims.map<Claim>((textClaim) => {
              return {
                className: ClaimClass.TEXT,
                pageNumber,
                text: textClaim.text,
              };
            })
          );
        } else {
          if (page.text && page.text.trim().length > 0) {
            request.claims.push({
              className: ClaimClass.TEXT,
              pageNumber,
              text: page.text,
            });
          }
        }
      }
    });
    if (request.claims.length === 0) {
      throw new DisclaimersError();
    }
    const imageFiles = this.getImages(document);
    const textData = this.getTexts(document);
    // const qualifiers = this.getQualifiers(document);
    const requestPromise = this.classificationDataProvider
      .getClassification(
        imageFiles,
        request,
        textData,
        qualifiers,
        marketingChannels,
        isExcel
      )
      .pipe(
        map((response: any) => {
          console.log('classify img response', response);
          response.results.forEach(obj => {
            if (!obj.hasOwnProperty('existing_qualifier')) {
              obj.existing_qualifier = [];
            }

            if(!obj.hasOwnProperty('marketing_channel')) {
              obj.marketing_channel = []

            }
          });
          this.normalizeClassificationResponse(response.results);
          response.text =
            document.type === DocumentType.TEXT
              ? document.pages[0].text
              : undefined;
          response.timestamp = new Date().getTime();
          response.images = imageFiles.map((value) => value.base64);
          response.metadata = metadata;
          response.coordinates = request.claims;
          return response;
        })
      )
      .toPromise();

    await this.cropImages(imageFiles, document);
    const classificationResponse = await requestPromise;

    classificationResponse.disclaimers = disclaimers;
    return classificationResponse;
  }
  //edit claims flow in EEOC
  async getEditClaimsClassification(): Promise<ClassificationReport> {
    const requestPromise = this.classificationDataProvider
      .getEEOCEditClaimsClassification()
      .pipe(
        map((response: any) => {
          return response;
        })
      )
      .toPromise();
    const classificationResponse = await requestPromise;
    return classificationResponse;
  }

  //edit LA flow in EEOC
  async getEditLAClassification(): Promise<ClassificationReport> {
    const requestPromise = this.classificationDataProvider
      .getEEOCEditClaimsClassification()
      .pipe(
        map((response: any) => {
          return response;
        })
      )
      .toPromise();
    // await this.cropImages(imageFiles, document);
    const classificationResponse = await requestPromise;
    return classificationResponse;
  }

  // async getExcelClassification(
  //   document: Document,
  //   metadata: Metadata,
  //   marketingChannels: [],
  //   btnClick: boolean,
  //   isExcel: boolean,
  //   excelBase64: any
  // ): Promise<ClassificationReport> {
  //   const requestPromise = this.classificationDataProvider
  //     .getEEOCExcelClassification(excelBase64, marketingChannels)
  //     .pipe(
  //       map((response: any) => {
  //         return response;
  //       })
  //     )
  //     .toPromise();
  //   const classificationResponse = await requestPromise;
  //   return classificationResponse;
  // }

  // private getClaimsFromImageClaim(
  //   imageClaim: ImageClaim,
  //   pageNumber: number,
  //   isBtnClick: boolean,
  //   isDisclaimer
  // ): any {
  //   let claims: Claim[] = [];
  //   if (imageClaim?.textClaims?.length > 0) {
  //     claims = imageClaim.textClaims.map<Claim>((textClaim) => {
  //       return {
  //         Label: imageClaim.className,
  //         pageNumber,
  //         text: textClaim.text,
  //       };
  //     });
  //     if (imageClaim.className !== ClaimClass.LOGO) {
  //       return claims;
  //     }
  //   } else {
  //     if (imageClaim.text?.length) {
  //       claims.push({
  //         Label: ClaimClass.TEXT,
  //         pageNumber,
  //         text: imageClaim.text,
  //       });
  //       if (imageClaim.className !== ClaimClass.LOGO) {
  //         return claims;
  //       }
  //     }
  //   }

  //   claims.push({
  //     Label: imageClaim.className,
  //     pageNumber,
  //     region: {
  //       xmin: imageClaim.region.leftTopX,
  //       ymin: imageClaim.region.leftTopY,
  //       xmax: imageClaim.region.rightBottomX,
  //       ymax: imageClaim.region.rightBottomY,
  //     },
  //     isNew: imageClaim.isNew && !isBtnClick ? imageClaim.isNew : false,
  //   });

  //   return claims;
  // }

  // private async cropImages(
  //   imageFiles: ImageFile[],
  //   document: Document
  // ): Promise<void> {
  //   if (imageFiles.length === 0) {
  //     return;
  //   }
  //   for (let pageNumber = 0; pageNumber < imageFiles.length; pageNumber++) {
  //     const page = document.pages[pageNumber];
  //     const claimsForCrop = _.filter(
  //       page.imageClaims,
  //       (claim) => !claim.base64
  //     );
  //     if (claimsForCrop.length === 0) {
  //       continue;
  //     }
  //     const croppedImages = await Converters.cropImages(
  //       imageFiles[pageNumber].base64,
  //       claimsForCrop.map((claim) => claim.region)
  //     );
  //     for (let i = 0; i < croppedImages.length; i++) {
  //       claimsForCrop[i].base64 = croppedImages[i];
  //     }
  //   }
  // }

  private isRegionsEquals(r1: RegionBox, r2: RegionBox): boolean {
    return (
      Math.abs(r1.leftTopX - r2.leftTopX) < Const.regionPrecision &&
      Math.abs(r1.leftTopY - r2.leftTopY) < Const.regionPrecision &&
      Math.abs(r1.rightBottomX - r2.rightBottomX) < Const.regionPrecision &&
      Math.abs(r1.rightBottomY - r2.rightBottomY) < Const.regionPrecision
    );
  }

  //function for normal flow classification from result page
  async getiRAClassification(
    document: Document,
    metadata: any,
    btnClick: boolean,
    isExcel: boolean,
    textValues: any,
    qualifiers: any,
    oldMarketingChannels: any,
    newMarketingChannels: any,
    uploadId: any,
    claimOrders: any,
    lifeCycle: any,
    lifeCycle_UI: any,
    relatedTranslations: any,
    qualifierTranslations: any,
    backTranslations: any,
    textExist: any,
    currentPage: any
  ): Promise<ClassificationReport> {
    const request: ClassificationRequest = {
      claims: [],
      metadata,
    };
    let disclaimers: Claim[] = [];
    document?.pages?.forEach((page, pageNumber) => {
      if (isExcel == false) {
        if (page.imageClaims.length > 0) {
          page.imageClaims.forEach((imageClaim) => {
            if (imageClaim.className === ClaimClass.DISCLAIMER) {
              disclaimers = _.concat(
                disclaimers,
                this.getClaimsFromImageClaim(
                  imageClaim,
                  pageNumber,
                  btnClick,
                  true
                )
              );
              request.claims = _.concat(
                request.claims,
                this.getClaimsFromImageClaim(
                  imageClaim,
                  pageNumber,
                  btnClick,
                  true
                )
              );
            } else {
              request.claims = _.concat(
                request.claims,
                this.getClaimsFromImageClaim(
                  imageClaim,
                  pageNumber,
                  btnClick,
                  false
                )
              );
            }
          });
          return;
        }
      } else {
        if (page.textClaims.length > 0) {
          request.claims = _.concat(
            request.claims,
            page.textClaims.map<Claim>((textClaim) => {
              return {
                className: ClaimClass.TEXT,
                pageNumber,
                text: textClaim.text,
              };
            })
          );
        } else {
          if (page.text && page.text.trim().length > 0) {
            request.claims.push({
              className: ClaimClass.TEXT,
              pageNumber,
              text: page.text,
            });
          }
        }
      }
    });

    const imageFiles = this.getImages(document);
    const textData = this.getTexts(document);
    const requestPromise = this.classificationDataProvider
      .getEeocRiskClassification(
        imageFiles,
        request,
        textData,
        isExcel,
        textValues,
        qualifiers,
        oldMarketingChannels,
        newMarketingChannels,
        uploadId,
        claimOrders,
        lifeCycle,
        lifeCycle_UI,
        relatedTranslations,
        qualifierTranslations,
        backTranslations,
        textExist,
        document,
        currentPage
      )
      .pipe(
        map((response: any) => {
          this.normalizeClassificationResponse(response.results);
          response.text =
            document.type === DocumentType.TEXT
              ? document.pages[0].text
              : undefined;
          response.timestamp = new Date().getTime();
          response.images = imageFiles.map((value) => value.base64);
          response.metadata = metadata;
          return response;
        })
      )
      .toPromise();

    await this.cropImages(imageFiles, document);
    const classificationResponse = await requestPromise;

    classificationResponse.disclaimers = disclaimers;
    return classificationResponse;
  }

  private normalizeClassificationResponse(response: ClassificationResult[]) {
    response.forEach((resultValue: any) => {
      if (resultValue.level == null) {
        resultValue.level = '0';
      }
      if (resultValue.risk == null) {
        resultValue.risk = '0';
      }
      if (resultValue.reason == null) {
        resultValue.reason = [];
      }
    });
  }

  private getClaimsFromImageClaim(
    imageClaim: ImageClaim,
    pageNumber: number,
    isBtnClick: boolean,
    isDisclaimer
  ): any {
    let claims: Claim[] = [];
    if (imageClaim?.textClaims?.length > 0) {
      claims = imageClaim.textClaims.map<Claim>((textClaim) => {
        return {
          Label: imageClaim.className,
          pageNumber,
          text: textClaim.text,
        };
      });
      if (imageClaim.className !== ClaimClass.LOGO) {
        return claims;
      }
    } else {
      if (imageClaim.text?.length) {
        claims.push({
          Label: ClaimClass.TEXT,
          pageNumber,
          text: imageClaim.text,
        });
        if (imageClaim.className !== ClaimClass.LOGO) {
          return claims;
        }
      }
    }

    claims.push({
      Label: imageClaim.className,
      pageNumber,
      region: {
        xmin: imageClaim.region.leftTopX,
        ymin: imageClaim.region.leftTopY,
        xmax: imageClaim.region.rightBottomX,
        ymax: imageClaim.region.rightBottomY,
      },
      isNew: imageClaim.isNew && !isBtnClick ? imageClaim.isNew : false,
    });

    return claims;
  }

  private async cropImages(
    imageFiles: ImageFile[],
    document: Document
  ): Promise<void> {
    if (imageFiles.length === 0) {
      return;
    }
    for (let pageNumber = 0; pageNumber < imageFiles.length; pageNumber++) {
      const page = document.pages[pageNumber];
      const claimsForCrop = _.filter(
        page.imageClaims,
        (claim) => !claim.base64
      );
      if (claimsForCrop.length === 0) {
        continue;
      }
      const croppedImages = await Converters.cropImages(
        imageFiles[pageNumber].base64,
        claimsForCrop.map((claim) => claim.region)
      );
      for (let i = 0; i < croppedImages.length; i++) {
        claimsForCrop[i].base64 = croppedImages[i];
      }
    }
  }

  // private addBase64(response: ClassificationResult[], document: Document) {
  //   response.forEach((resultValue: any) => {
  //     if (resultValue.claim.region) {
  //       const page = document.pages[resultValue.claim.pageNumber];
  //       const imageClaim = page.imageClaims.find((value) => {
  //         return this.isRegionsEquals(resultValue.claim.region, value.region);
  //       });
  //       resultValue.claim.image = imageClaim?.base64 || page.image;
  //     }
  //   });
  // }

  // private normalizeClassificationResponse(response: ClassificationResult[]) {
  //   response.forEach((resultValue: any) => {
  //     if (resultValue.level == null) {
  //       resultValue.level = '0';
  //     }
  //     if (resultValue.risk == null) {
  //       resultValue.risk = '0';
  //     }
  //     if (resultValue.reason == null) {
  //       resultValue.reason = [];
  //     }
  //   });
  // }

  //function for normal flow classification
  // async getiRAClassification(
  //   document: Document,
  //   metadata: Metadata,
  //   btnClick: boolean,
  //   isExcel: boolean,
  //   textValues: any,
  //   qualifiers: any,
  //   oldMarketingChannels: any,
  //   newMarketingChannels: any,
  //   uploadId: any,
  //   claimOrders: any,
  //   lifeCycle: any,
  //   lifeCycle_UI: any,
  //   relatedTranslations: any,
  //   qualifierTranslations: any,
  //   backTranslations: any,
  //   textExist: any,
  //   currentPage: any
  // ): Promise<ClassificationReport> {
  //   const request: ClassificationRequest = {
  //     claims: [],
  //     metadata,
  //   };
  //   let disclaimers: Claim[] = [];
  //   document.pages.forEach((page, pageNumber) => {
  //     if (isExcel == false) {
  //       if (page.imageClaims.length > 0) {
  //         page.imageClaims.forEach((imageClaim) => {
  //           if (imageClaim.className === ClaimClass.DISCLAIMER) {
  //             disclaimers = _.concat(
  //               disclaimers,
  //               this.getClaimsFromImageClaim(
  //                 imageClaim,
  //                 pageNumber,
  //                 btnClick,
  //                 true
  //               )
  //             );
  //             request.claims = _.concat(
  //               request.claims,
  //               this.getClaimsFromImageClaim(
  //                 imageClaim,
  //                 pageNumber,
  //                 btnClick,
  //                 true
  //               )
  //             );
  //           } else {
  //             request.claims = _.concat(
  //               request.claims,
  //               this.getClaimsFromImageClaim(
  //                 imageClaim,
  //                 pageNumber,
  //                 btnClick,
  //                 false
  //               )
  //             );
  //           }
  //         });
  //         return;
  //       }
  //     } else {
  //       if (page.textClaims.length > 0) {
  //         request.claims = _.concat(
  //           request.claims,
  //           page.textClaims.map<Claim>((textClaim) => {
  //             return {
  //               className: ClaimClass.TEXT,
  //               pageNumber,
  //               text: textClaim.text,
  //             };
  //           })
  //         );
  //       } else {
  //         if (page.text && page.text.trim().length > 0) {
  //           request.claims.push({
  //             className: ClaimClass.TEXT,
  //             pageNumber,
  //             text: page.text,
  //           });
  //         }
  //       }
  //     }
  //   });

  //   const imageFiles = this.getImages(document);
  //   const textData = this.getTexts(document);
  //   const requestPromise = this.classificationDataProvider
  //     .getEeocRiskClassification(
  //       imageFiles,
  //       request,
  //       textData,
  //       isExcel,
  //       textValues,
  //       qualifiers,
  //       oldMarketingChannels,
  //       newMarketingChannels,
  //       uploadId,
  //       claimOrders,
  //       lifeCycle,
  //       lifeCycle_UI,
  //       relatedTranslations,
  //       qualifierTranslations,
  //       backTranslations,
  //       textExist,
  //       document,
  //       currentPage
  //     )
  //     .pipe(
  //       map((response: any) => {
  //         this.normalizeClassificationResponse(response.results);
  //         response.text =
  //           document.type === DocumentType.TEXT
  //             ? document.pages[0].text
  //             : undefined;
  //         response.timestamp = new Date().getTime();
  //         response.images = imageFiles.map((value) => value.base64);
  //         response.metadata = metadata;
  //         return response;
  //       })
  //     )
  //     .toPromise();

  //   await this.cropImages(imageFiles, document);
  //   const classificationResponse = await requestPromise;

  //   classificationResponse.disclaimers = disclaimers;
  //   return classificationResponse;
  // }

  //function for edit claims flow classification
  // async getEditClaimsiRAClassification(
  //   document: Document,
  //   metadata: Metadata,
  //   btnClick: boolean,
  //   isExcel: boolean,
  //   textValues: any,
  //   qualifiers: any,
  //   oldMarketingChannels: any,
  //   newMarketingChannels: any,
  //   uploadId: any,
  //   claimOrders: any,
  //   lifeCycle: any,
  //   lifeCycle_UI: any,
  //   relatedTranslations: any,
  //   qualifierTranslations: any,
  //   backTranslations: any,
  //   textExist: any
  // ): Promise<ClassificationReport> {
  //   const request: ClassificationRequest = {
  //     claims: [],
  //     metadata,
  //   };
  //   let disclaimers: Claim[] = [];
  //   const imageFiles = [];
  //   const textData = [];
  //   const requestPromise = this.classificationDataProvider
  //     .getEeocRiskClassification(
  //       imageFiles,
  //       request,
  //       textData,
  //       isExcel,
  //       textValues,
  //       qualifiers,
  //       oldMarketingChannels,
  //       newMarketingChannels,
  //       uploadId,
  //       claimOrders,
  //       lifeCycle,
  //       lifeCycle_UI,
  //       relatedTranslations,
  //       qualifierTranslations,
  //       backTranslations,
  //       textExist,
  //       {},
  //       {}
  //     )
  //     .pipe(
  //       map((response: any) => {
  //         this.normalizeClassificationResponse(response.results);
  //         response.timestamp = new Date().getTime();
  //         response.metadata = metadata;
  //         return response;
  //       })
  //     )
  //     .toPromise();

  //   await this.cropImages(imageFiles, document);
  //   const classificationResponse = await requestPromise;

  //   classificationResponse.disclaimers = disclaimers;
  //   return classificationResponse;
  // }

  //function for edit LA flow classification
  async getEditLAiRAClassification(
    document: Document,
    metadata: any,
    btnClick: boolean,
    isExcel: boolean,
    textValues: any,
    qualifiers: any,
    oldMarketingChannels: any,
    newMarketingChannels: any,
    uploadId: any,
    claimOrders: any,
    lifeCycle: any,
    lifeCycle_UI: any,
    relatedTranslations: any,
    qualifierTranslations: any,
    backTranslations: any,
    textExist: any,
    language: any,
    projectExists: any,
    statementLanguages: any,
    translateLanguages: any,
    claimID: any,
    relatedID: any,
    statementID: any,
    updatedStatus: any,
     masterExists:any,
  ): Promise<ClassificationReport> {
    const request: ClassificationRequest = {
      claims: [],
      metadata,
    };
    let disclaimers: Claim[] = [];

    const imageFiles = [];
    const textData = [];

    const requestPromise = this.classificationDataProvider
      .getEeocEditLARiskClassification(
        imageFiles,
        request,
        textData,
        isExcel,
        textValues,
        qualifiers,
        oldMarketingChannels,
        newMarketingChannels,
        uploadId,
        claimOrders,
        lifeCycle,
        lifeCycle_UI,
        relatedTranslations,
        qualifierTranslations,
        backTranslations,
        textExist,
        language,
        projectExists,
        statementLanguages,
        translateLanguages,
        claimID,
        relatedID,
        statementID,
        updatedStatus,
         masterExists,
        {},
        {}
      )
      .pipe(
        map((response: any) => {
          this.normalizeClassificationResponse(response.results);
          response.timestamp = new Date().getTime();
          response.metadata = metadata;
          response.images = [];
          return response;
        })
      )
      .toPromise();

    await this.cropImages(imageFiles, document);
    const classificationResponse = await requestPromise;

    classificationResponse.disclaimers = disclaimers;
    return classificationResponse;
  }

  getMarketingChannelData() {
    return this.classificationDataProvider.getMarketingChannels().pipe(
      map((response: any) => {
        return {
          text: response.marketing_channels,
        };
      })
    );
  }
}
